<template>
  <v-menu
    location="bottom"
    :max-height="height"
    transition="slide-x-reverse-transition"
  >
    <template #activator="{ props }">
      <v-btn
        v-tooltip:bottom="'History'"
        variant="plain"
        v-bind="props"
      >
        <v-icon icon="fa-sharp-duotone fa-clock-rotate-left" />
      </v-btn>
    </template>

    <v-list
      theme="dark"
      class="mainpanel"
      two-line
    >
      <v-list-subheader>History</v-list-subheader>

      <v-list-item
        v-for="(history, l) in routeStore.getHistory"
        :key="'history_'+l"
        :title="history.value.name"
        :subtitle="history.value.path"
        @click="loadbook(history.value.path)"
      />
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { useAppStore } from "../stores/app";
import { useRouteStore } from "../stores/routes";
import router from "../router";

const appStore = useAppStore();
const routeStore = useRouteStore();

const props = defineProps({
  height: Number,
})

function loadbook(book: string) {
  appStore.currentPage = 1;

  if (book === "/")
  {
    router.push({
      name: 'Listing'
    });
  } else {
    appStore.fileName = book.replace("/viewer/", "");
    appStore.file = "https://data.tdot.men/pdf/" + appStore.fileName + ".pdf";

    router.push({
      name: 'Viewer',
      params: {
        file: appStore.fileName
      }
    });
  }
}

</script>
